import { render, staticRenderFns } from "./Products.vue?vue&type=template&id=f838c16c&scoped=true&"
import script from "./Products.vue?vue&type=script&lang=js&"
export * from "./Products.vue?vue&type=script&lang=js&"
import style0 from "./Products.vue?vue&type=style&index=0&id=f838c16c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f838c16c",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/workspace/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('f838c16c')) {
      api.createRecord('f838c16c', component.options)
    } else {
      api.reload('f838c16c', component.options)
    }
    module.hot.accept("./Products.vue?vue&type=template&id=f838c16c&scoped=true&", function () {
      api.rerender('f838c16c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "public/js/src/app/components/purchase-activity/reports/Products.vue"
export default component.exports